import React, { useEffect, useState } from "react";
import Cards from "../../components/Cards/Cards";
import "./OurServicesScreen.css";

interface OurServicesScreenProps {
  ourServicesRef?: React.MutableRefObject<HTMLDivElement | null>;
}

const servicesData = [
  {
    image: require("../../assets/images/FreightTransportation.png"),
    label: "Freight Transportation",
    description: "Reliable delivery of goods across Luzon.",
  },
  {
    image: require("../../assets/images/SpecializedTransportation.png"),
    label: "Specialized Transportation",
    description: "Handling of oversized or sensitive cargo.",
  },
  {
    image: require("../../assets/images/IntermodalTransportation.png"),
    label: "Combined Transportation",
    description: "Combining various transport modes for efficiency.",
  },
];

const OurServicesScreen: React.FC<OurServicesScreenProps> = ({
  ourServicesRef,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-scroll loop for mobile view
  useEffect(() => {
    if (window.innerWidth > 768) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % servicesData.length);
    }, 3500);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="our-services-container" id="ourServices" ref={ourServicesRef}>
      <div className="our-services-content-container">
        <div className="trucking-services-label-container">
          <h2 className="trucking-services-label">Trucking Services</h2>
        </div>

        {/* Desktop View: Shows all 3 cards in a row */}
        <div className="our-services-card-container desktop-only">
          {servicesData.map((service, index) => (
            <div className="carousel-card-item" key={index}>
              <Cards
                image={service.image}
                label={service.label}
                description={service.description}
              />
            </div>
          ))}
        </div>

        {/* Mobile View: Controlled single card slider (guarantees first card is visible) */}
        <div className="our-services-card-container mobile-only">
          <div className="carousel-card-item active">
            <Cards
              image={servicesData[currentIndex].image}
              label={servicesData[currentIndex].label}
              description={servicesData[currentIndex].description}
            />
          </div>
        </div>

        {/* Pagination Dots */}
        <div className="carousel-dots">
          {servicesData.map((_, index) => (
            <span
              key={index}
              className={`dot ${currentIndex === index ? "active" : ""}`}
              onClick={() => setCurrentIndex(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurServicesScreen;